// removed by extract-text-webpack-plugin
module.exports = {"footer":"_21gmWlKW5qC4Oj43BrZeA2","footer__button":"_1fhaX7qTjPly3Iz2yBwYiz","footer__button-block":"G3ADLFQXWUGcdcMQpGJ9y","footer_minimized":"e9zw7wstUYYZyWcj87Ce3"};